import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("hrms_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("hrms_token");
        localStorage.removeItem("hrms_user");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("hrms_token", data.token);
    localStorage.setItem("hrms_user", JSON.stringify(data));
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("hrms_token");
    localStorage.removeItem("hrms_user");
    setUser(null);
  };

  // Called after a successful password change to clear the forced flag
  const clearMustChangePassword = () => {
    setUser((u) => (u ? { ...u, must_change_password: false } : u));
  };

  /** Re-fetch /auth/me so role matrix / role_ids changes apply without full re-login. */
  const refreshUser = async () => {
    const token = localStorage.getItem("hrms_token");
    if (!token) return null;
    const { data } = await api.get("/auth/me");
    localStorage.setItem("hrms_user", JSON.stringify(data));
    setUser(data);
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, clearMustChangePassword, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
